export default "__VITE_ASSET__fe34d428__"